import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {AppConfigService} from './app-config.service';
import {lastValueFrom, Observable, throwError} from 'rxjs';
import {ResponseModel} from '../DataModels/response-model';
import {take} from 'rxjs/operators';


@Injectable()
export class DataService {

  endpointUrl = null;

  constructor(protected http: HttpClient,
              private appConfigService: AppConfigService) {
    this.endpointUrl = this.appConfigService.apiBaseUrl;
  }

// TODO NOTE - Do NOT surface errors here any longer - interceptor service catches them

  getData(endPoint: string, params: string = null): Observable<any> {
    let url = null;
    if (params !== null) {
      url = this.endpointUrl + endPoint + '/' + params;
    } else {
      url = this.endpointUrl + endPoint;
    }
    return this.http.get(url).pipe(take(1));
  }

  getDataByArray(endPoint: string, params: HttpParams): Observable<any> {
    const url = this.endpointUrl + endPoint;
    return this.http.get(url, {params}).pipe(take(1));
  }

  getApiListData(endPoint: string, params: string = null): Observable<any> {
    let url = null;
    if (params !== null) {
      url = this.endpointUrl + endPoint + '/' + params;
    } else {
      url = this.endpointUrl + endPoint;
    }
    return this.http.get<ResponseModel>(url).pipe(take(1));
  }

  getDataWithParams(endPoint: string, params: string = null): Observable<any> {
    let url = null;
    if (params !== null) {
      url = this.endpointUrl + endPoint + '?' + params;
    } else {
      url = this.endpointUrl + endPoint;
    }

    return this.http.get(url).pipe(take(1));
  }

  async patch(endPoint: string, params: string, obj: object) {
    const url = this.endpointUrl + endPoint + '/' + params;

    return lastValueFrom(this.http.patch(url, obj))
      .then((result: any) => {
        return result;
      })
      .catch((err: any) => {
        // do error stuff here - but in our case the interceptor catches all errors.
      });
  }

  async patchWithParamsNew(endPoint: string, params: string, obj: object) {
    const url = this.endpointUrl + endPoint + '/' + params;

    return lastValueFrom(this.http.patch(url, obj))
      .then((result: any) => {
        return result;
      })
      .catch((err: any) => {
        // do error stuff here - but in our case the interceptor catches all errors.
      });
  }


  deleteDataById(endPoint: string, params: string): Observable<any> {
    const url = this.endpointUrl + endPoint + '/' + params;

    return this.http.delete(url).pipe(take(1));
  }

  deleteDataByArray(endPoint: string, obj: object): Observable<any> {
    const url = this.endpointUrl + endPoint;
    const httpOptions = {
       body: obj
     };
    return this.http.delete(url, httpOptions).pipe(take(1));
  }

  put(endPoint: string, params: string, obj: object): Observable<any> {
    const url = this.endpointUrl + endPoint + '/' + params;

    return this.http.put(url, obj).pipe(take(1));
  }

  putDataByArray(endPoint: string, obj: object): Observable<any> {
    const url = this.endpointUrl + endPoint;

    return this.http.put(url, obj).pipe(take(1));
  }

  patchDataByArray(endPoint: string, obj: object): Observable<any> {
    const url = this.endpointUrl + endPoint;

    return this.http.patch(url, obj).pipe(take(1));
  }

  // uses header Silent true to tell api send back a 418 which is picked off by error interceptor and not displayed; hence silent.
  putDataByArraySilent(endPoint: string, obj: object): Observable<any> {
    const url = this.endpointUrl + endPoint;
    const headers = new HttpHeaders().append('Silent', 'true');

    return this.http.put(url, obj, {headers}).pipe(take(1));
  }

  post(endPoint: string, obj: object): Observable<any> {
    const url = this.endpointUrl + endPoint;

    return this.http.post(url, obj).pipe(take(1));
  }

  getBlob(endPoint: string): Observable<Blob> {
    const url = this.endpointUrl + endPoint;
    return this.http.get(url, {responseType: 'blob'}).pipe(take(1));
  }

  postFormData(endPoint: string, formData: FormData): Observable<any> {
    const url = this.endpointUrl + endPoint;
    return this.http.post(url, formData).pipe(take(1));
  }

  postFormDataSilent(endPoint: string, formData: FormData): Observable<any> {
    const url = this.endpointUrl + endPoint;
    const headers = new HttpHeaders().append('Silent', 'true');
    return this.http.post(url, formData, {headers}).pipe(take(1));
  }

  async postWithPromise(endPoint: string, obj: object) {
    const url = this.endpointUrl + endPoint;

    return lastValueFrom(this.http.post(url, obj))
      .then((result: any) => {
        return result;
      })
      .catch((err: any) => {
        // do error stuff here - but in our case the interceptor catches all errors.
      });
  }

}


